import { create } from "zustand";
import { authenticatedAxios, baseURL } from "../../apis";

const useProxyStore = create((set, get) => ({
  proxies: [],
  pagination: {
    page: 1,
    size: 10,
    max_page: 1,
    total_items: 0,
  },

  proxyDetail: null,

  loadingList: false,
  loadingAction: false,
  error: null,

  actions: {
    // =============================
    // GET LIST (real response format)
    // =============================
    fetchList: async ({ page = 1, size = 10 }) => {
      set({ loadingList: true, error: null });

      try {
        const { data } = await authenticatedAxios.get(
          `${baseURL}/api/admin/proxy/?page=${page}&size=${size}`
        );

        set({
          proxies: data.data || [],
          pagination: {
            page: data.pagination.page,
            size: data.pagination.size,
            max_page: data.pagination.max_page,
            total_items: data.pagination.total_items,
          },
        });
      } catch (e) {
        set({
          error: e?.response?.data?.message || e.message,
        });
      } finally {
        set({ loadingList: false });
      }
    },

    // =============================
    // GET DETAIL
    // =============================
    fetchDetail: async (id) => {
      set({ loadingAction: true, error: null });

      try {
        const { data } = await authenticatedAxios.get(
          `${baseURL}/api/admin/proxy/${id}/`
        );
        set({ proxyDetail: data });
      } catch (e) {
        set({ error: e?.response?.data?.message || e.message });
      } finally {
        set({ loadingAction: false });
      }
    },

    // =============================
    // CREATE
    // =============================
    createProxy: async (payload) => {
      set({ loadingAction: true });

      try {
        await authenticatedAxios.post(
          `${baseURL}/api/admin/proxy/create/`,
          payload
        );

        await get().actions.fetchList({ page: 1, size: get().pagination.size });
      } catch (e) {
        set({ error: e?.response?.data?.message || e.message });
      } finally {
        set({ loadingAction: false });
      }
    },

    // =============================
    // UPDATE
    // =============================
    updateProxy: async (id, payload) => {
      set({ loadingAction: true });

      try {
        await authenticatedAxios.put(
          `${baseURL}/api/admin/proxy/${id}/update/`,
          payload
        );

        const { page, size } = get().pagination;
        await get().actions.fetchList({ page, size });
      } catch (e) {
        set({ error: e?.response?.data?.message || e.message });
      } finally {
        set({ loadingAction: false });
      }
    },

    // =============================
    // DELETE
    // =============================
    deleteProxy: async (id) => {
      set({ loadingAction: true });

      try {
        await authenticatedAxios.delete(
          `${baseURL}/api/admin/proxy/${id}/delete/`
        );

        const { page, size } = get().pagination;
        await get().actions.fetchList({ page, size });
      } catch (e) {
        set({ error: e?.response?.data?.message || e.message });
      } finally {
        set({ loadingAction: false });
      }
    },

    // =============================
    // TOGGLE ACTIVE
    // =============================
    toggleActive: async (id, isActive) => {
      set({ loadingAction: true });

      try {
        await authenticatedAxios.put(
          `${baseURL}/api/admin/proxy/${id}/update/`,
          { is_active: isActive }
        );

        const { page, size } = get().pagination;
        await get().actions.fetchList({ page, size });
      } catch (e) {
        set({ error: e?.response?.data?.message || e.message });
      } finally {
        set({ loadingAction: false });
      }
    },
  },
}));

export default useProxyStore;
